import type { OwnedAccount } from '@hotjar/account';
import {
  closedModal,
  extractAccountGroupingProps,
  loadedModal,
  trackClick,
} from '@hotjar/tracking';

const MODAL_NAME = 'Change plan confirmation multi sku churn deflection';

export function trackModalLoaded(account: OwnedAccount | undefined): void {
  loadedModal(MODAL_NAME, extractAccountGroupingProps(account));
}

export function trackModalClosed(account: OwnedAccount | undefined): void {
  closedModal(MODAL_NAME, extractAccountGroupingProps(account));
}

export function trackContinueToDowngradeClick(account: OwnedAccount | undefined): void {
  trackClick({
    name: 'Continue to downgrade',
    uiPosition: MODAL_NAME,
    groupData: extractAccountGroupingProps(account),
  });
}

export function trackKeepPlansClick(account: OwnedAccount | undefined): void {
  trackClick({
    name: 'Keep plans',
    uiPosition: MODAL_NAME,
    groupData: extractAccountGroupingProps(account),
  });
}

export function trackComparePlansClick(account: OwnedAccount | undefined): void {
  trackClick({
    name: 'Compare plans',
    uiPosition: MODAL_NAME,
    groupData: extractAccountGroupingProps(account),
  });
}

export function trackMakeEnquiryClick(account: OwnedAccount | undefined): void {
  trackClick({
    name: 'Make an enquiry',
    uiPosition: MODAL_NAME,
    groupData: extractAccountGroupingProps(account),
  });
}
